/**
 * 上传框的文件上传/URL输入部分
 */
import React, { useCallback } from 'react'
import { FileUploader } from '@tencent/spaui-uploader'
import Input from '@tencent/spaui-input'
import FormGroup from '@tencent/spaui-formgroup'
import { UPLOAD_TYPES } from 'constants.js'

export const isSingle = dialogType => {
    return dialogType === 'singleReplace'
}

const DialogUploadContent = ({ uploadType, dialogType, formData, formError, onFormDataChange }) => {
    const getField = _uploadType => {
        return _uploadType === UPLOAD_TYPES.LOCAL_UPLOAD ? 'files' : 'urlFile'
    }

    const handleFileDelete = useCallback(() => {
        onFormDataChange && onFormDataChange(getField(uploadType), [])
        // SPAUI FileUploader 组件需保证每次传的函数引用是一样的
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadType])

    const handleFileChange = useCallback(
        e => {
            onFormDataChange(getField(uploadType), e.target.files)
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [uploadType]
    )

    const genComponent = () => {
        let comp = null
        switch (uploadType) {
            case UPLOAD_TYPES.LOCAL_UPLOAD:
            case UPLOAD_TYPES.UPLOAD_LINK_CSV: {
                let uploadText = ''
                if (uploadType === UPLOAD_TYPES.LOCAL_UPLOAD) {
                    uploadText = '选择渠道包'
                } else {
                    uploadText = '选择下载链接'
                }
                comp = (
                    <FileUploader
                        key={`file_uploader_${uploadType}`}
                        name="file"
                        className="spaui-upfile-full-width"
                        uploadText={uploadText}
                        autoUpload={false}
                        onDelete={handleFileDelete}
                        onFileChange={handleFileChange}
                        multiple={!isSingle(dialogType) && uploadType === UPLOAD_TYPES.LOCAL_UPLOAD}
                    />
                )
                break
            }
            case UPLOAD_TYPES.INPUT_LINK: {
                comp = (
                    <FormGroup error={formError.url}>
                        <Input
                            value={formData.url}
                            placeholder="请输入下载链接"
                            onChange={(e, val) => onFormDataChange('url', val)}
                        />
                    </FormGroup>
                )
                break
            }
            default:
        }
        return comp
    }

    return <div className="track-body-item">{genComponent()}</div>
}

export default DialogUploadContent
